var mixin;

import Modal from 'trunks/vue/admin/components/modals/modal.js';

import ShuttleContainerCandidates from "../shuttle_container/candidates.js";

export default mixin = {
  components: {
    'modal': Modal,
    'shuttle-container-candidates': ShuttleContainerCandidates
  },
  props: {
    organization: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {
      selectedOrganizationId: 'members'
    };
  },
  methods: {
    updateSelectedOrganizationIdFunc: function(id) {
      return this.selectedOrganizationId = id;
    },
    open: function() {
      return this.$refs.modal.open();
    },
    cancel: function() {
      return this.$refs.modal.close();
    }
  }
};
